import { InjectionToken, ɵɵinject, ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, Optional, Inject, ɵɵdefineNgModule, ɵɵdefineInjector, NgModule, SkipSelf } from '@angular/core';
import { HttpUrlEncodingCodec, HttpHeaders, HttpParams, HttpClient } from '@angular/common/http';

/**
* CustomHttpUrlEncodingCodec
* Fix plus sign (+) not encoding, so sent as blank space
* See: https://github.com/angular/angular/issues/11058#issuecomment-247367318
*/
class CustomHttpUrlEncodingCodec extends HttpUrlEncodingCodec {
    encodeKey(k) {
        k = super.encodeKey(k);
        return k.replace(/\+/gi, '%2B');
    }
    encodeValue(v) {
        v = super.encodeValue(v);
        return v.replace(/\+/gi, '%2B');
    }
}
class CustomParamFilterHttpUrlEncodingCodec extends HttpUrlEncodingCodec {
    encodeKey(k) {
        return k;
    }
    encodeValue(v) {
        return v;
    }
}

const BASE_PATH = new InjectionToken('basePath');
const COLLECTION_FORMATS = {
    'csv': ',',
    'tsv': '   ',
    'ssv': ' ',
    'pipes': '|'
};

class Configuration {
    constructor(configurationParameters = {}) {
        this.apiKeys = configurationParameters.apiKeys;
        this.username = configurationParameters.username;
        this.password = configurationParameters.password;
        this.accessToken = configurationParameters.accessToken;
        this.basePath = configurationParameters.basePath;
        this.withCredentials = configurationParameters.withCredentials;
    }
    /**
     * Select the correct content-type to use for a request.
     * Uses {@link Configuration#isJsonMime} to determine the correct content-type.
     * If no content type is found return the first found type if the contentTypes is not empty
     * @param contentTypes - the array of content types that are available for selection
     * @returns the selected content-type or <code>undefined</code> if no selection could be made.
     */
    selectHeaderContentType(contentTypes) {
        if (contentTypes.length == 0) {
            return undefined;
        }
        let type = contentTypes.find(x => this.isJsonMime(x));
        if (type === undefined) {
            return contentTypes[0];
        }
        return type;
    }
    /**
     * Select the correct accept content-type to use for a request.
     * Uses {@link Configuration#isJsonMime} to determine the correct accept content-type.
     * If no content type is found return the first found type if the contentTypes is not empty
     * @param accepts - the array of content types that are available for selection.
     * @returns the selected content-type or <code>undefined</code> if no selection could be made.
     */
    selectHeaderAccept(accepts) {
        if (accepts.length == 0) {
            return undefined;
        }
        let type = accepts.find(x => this.isJsonMime(x));
        if (type === undefined) {
            return accepts[0];
        }
        return type;
    }
    /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param mime - MIME (Multipurpose Internet Mail Extensions)
     * @return True if the given MIME is JSON, false otherwise.
     */
    isJsonMime(mime) {
        const jsonMime = new RegExp('^(application\/json|[^;/ \t]+\/[^;/ \t]+[+]json)[ \t]*(;.*)?$', 'i');
        return mime != null && (jsonMime.test(mime) || mime.toLowerCase() === 'application/json-patch+json');
    }
}

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class AssetsService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'https://spare-gmbh.tvf-rest001.tvfactory.ch/pa/sdp/v2';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    addBookmark(position, assetId, observe = 'body', reportProgress = false) {
        if (position === null || position === undefined) {
            throw new Error('Required parameter position was null or undefined when calling addBookmark.');
        }
        if (assetId === null || assetId === undefined) {
            throw new Error('Required parameter assetId was null or undefined when calling addBookmark.');
        }
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (position !== undefined && position !== null) {
            queryParameters = queryParameters.set('position', position);
        }
        let headers = this.defaultHeaders;
        // authentication (ApiKeyXAuthToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-Auth-Token"]) {
            headers = headers.set('X-Auth-Token', this.configuration.apiKeys["X-Auth-Token"]);
        }
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json; charset=utf-8',
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('post', `${this.basePath}/assets/${encodeURIComponent(String(assetId))}/commands/add-bookmark`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    addToFavorite(assetId, observe = 'body', reportProgress = false) {
        if (assetId === null || assetId === undefined) {
            throw new Error('Required parameter assetId was null or undefined when calling addToFavorite.');
        }
        let headers = this.defaultHeaders;
        // authentication (ApiKeyXAuthToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-Auth-Token"]) {
            headers = headers.set('X-Auth-Token', this.configuration.apiKeys["X-Auth-Token"]);
        }
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json; charset=utf-8',
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('post', `${this.basePath}/assets/${encodeURIComponent(String(assetId))}/commands/add-to-favorites`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    getAssetsList(params, filter, xLanguage, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({ encoder: new CustomParamFilterHttpUrlEncodingCodec() });
        if (params !== undefined && params !== null) {
            queryParameters = queryParameters.set('params', params);
        }
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('filter', filter);
        }
        let headers = this.defaultHeaders;
        if (xLanguage !== undefined && xLanguage !== null) {
            headers = headers.set('X-Language', String(xLanguage));
        }
        // authentication (ApiKeyXAuthToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-Auth-Token"]) {
            headers = headers.set('X-Auth-Token', this.configuration.apiKeys["X-Auth-Token"]);
        }
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json; charset=utf-8',
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/assets`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    getChannelByID(id, expand, xLanguage, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getChannelByID.');
        }
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (expand !== undefined && expand !== null) {
            queryParameters = queryParameters.set('$expand', expand);
        }
        let headers = this.defaultHeaders;
        if (xLanguage !== undefined && xLanguage !== null) {
            headers = headers.set('X-Language', String(xLanguage));
        }
        // authentication (ApiKeyXAuthToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-Auth-Token"]) {
            headers = headers.set('X-Auth-Token', this.configuration.apiKeys["X-Auth-Token"]);
        }
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json; charset=utf-8',
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/assets/${encodeURIComponent(String(id))}`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    getChannelStream(channelId, resourceId, observe = 'body', reportProgress = false) {
        if (channelId === null || channelId === undefined) {
            throw new Error('Required parameter channelId was null or undefined when calling getChannelStream.');
        }
        if (resourceId === null || resourceId === undefined) {
            throw new Error('Required parameter resourceId was null or undefined when calling getChannelStream.');
        }
        let headers = this.defaultHeaders;
        // authentication (ApiKeyXAuthToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-Auth-Token"]) {
            headers = headers.set('X-Auth-Token', this.configuration.apiKeys["X-Auth-Token"]);
        }
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json; charset=utf-8',
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/assets/${encodeURIComponent(String(channelId))}/resources/${encodeURIComponent(String(resourceId))}/url`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    getPackageAssets(packageId, expand, xLanguage, observe = 'body', reportProgress = false) {
        if (packageId === null || packageId === undefined) {
            throw new Error('Required parameter packageId was null or undefined when calling getPackageAssets.');
        }
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (expand !== undefined && expand !== null) {
            queryParameters = queryParameters.set('$expand', expand);
        }
        let headers = this.defaultHeaders;
        if (xLanguage !== undefined && xLanguage !== null) {
            headers = headers.set('X-Language', String(xLanguage));
        }
        // authentication (ApiKeyXAuthToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-Auth-Token"]) {
            headers = headers.set('X-Auth-Token', this.configuration.apiKeys["X-Auth-Token"]);
        }
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json; charset=utf-8',
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/assets/${encodeURIComponent(String(packageId))}/package-assets`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    removeBookmark(assetId, observe = 'body', reportProgress = false) {
        if (assetId === null || assetId === undefined) {
            throw new Error('Required parameter assetId was null or undefined when calling removeBookmark.');
        }
        let headers = this.defaultHeaders;
        // authentication (ApiKeyXAuthToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-Auth-Token"]) {
            headers = headers.set('X-Auth-Token', this.configuration.apiKeys["X-Auth-Token"]);
        }
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json; charset=utf-8',
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('post', `${this.basePath}/assets/${encodeURIComponent(String(assetId))}/commands/remove-bookmark`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    removeFromFavorite(assetId, observe = 'body', reportProgress = false) {
        if (assetId === null || assetId === undefined) {
            throw new Error('Required parameter assetId was null or undefined when calling removeFromFavorite.');
        }
        let headers = this.defaultHeaders;
        // authentication (ApiKeyXAuthToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-Auth-Token"]) {
            headers = headers.set('X-Auth-Token', this.configuration.apiKeys["X-Auth-Token"]);
        }
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json; charset=utf-8',
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('post', `${this.basePath}/assets/${encodeURIComponent(String(assetId))}/commands/remove-from-favorites`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
AssetsService.ɵfac = function AssetsService_Factory(t) { return new (t || AssetsService)(ɵɵinject(HttpClient), ɵɵinject(BASE_PATH, 8), ɵɵinject(Configuration, 8)); };
AssetsService.ɵprov = ɵɵdefineInjectable({ token: AssetsService, factory: AssetsService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AssetsService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class AuthorizeService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'https://spare-gmbh.tvf-rest001.tvfactory.ch/pa/sdp/v2';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    authorizeForm(grantType, deviceId, clientId, username, password, deviceModel, deviceOs, deviceOsVersion, deviceAppVersion, deviceAppName, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json; charset=utf-8',
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [
            'application/x-www-form-urlencoded'
        ];
        const canConsumeForm = this.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        }
        if (grantType !== undefined) {
            formParams = formParams.append('grant_type', grantType) || formParams;
        }
        if (deviceId !== undefined) {
            formParams = formParams.append('device_id', deviceId) || formParams;
        }
        if (clientId !== undefined) {
            formParams = formParams.append('client_id', clientId) || formParams;
        }
        if (username !== undefined) {
            formParams = formParams.append('username', username) || formParams;
        }
        if (password !== undefined) {
            formParams = formParams.append('password', password) || formParams;
        }
        if (deviceModel !== undefined) {
            formParams = formParams.append('device_model', deviceModel) || formParams;
        }
        if (deviceOs !== undefined) {
            formParams = formParams.append('device_os', deviceOs) || formParams;
        }
        if (deviceOsVersion !== undefined) {
            formParams = formParams.append('device_os_version', deviceOsVersion) || formParams;
        }
        if (deviceAppVersion !== undefined) {
            formParams = formParams.append('device_app_version', deviceAppVersion) || formParams;
        }
        if (deviceAppName !== undefined) {
            formParams = formParams.append('device_app_name', deviceAppName) || formParams;
        }
        return this.httpClient.request('post', `${this.basePath}/authorize`, {
            body: convertFormParamsToString ? formParams.toString() : formParams,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
AuthorizeService.ɵfac = function AuthorizeService_Factory(t) { return new (t || AuthorizeService)(ɵɵinject(HttpClient), ɵɵinject(BASE_PATH, 8), ɵɵinject(Configuration, 8)); };
AuthorizeService.ɵprov = ɵɵdefineInjectable({ token: AuthorizeService, factory: AuthorizeService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AuthorizeService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class LiveEventsService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'https://spare-gmbh.tvf-rest001.tvfactory.ch/pa/sdp/v2';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    getCatchupStreamByLiveEventID(liveEventId, observe = 'body', reportProgress = false) {
        if (liveEventId === null || liveEventId === undefined) {
            throw new Error('Required parameter liveEventId was null or undefined when calling getCatchupStreamByLiveEventID.');
        }
        let headers = this.defaultHeaders;
        // authentication (ApiKeyXAuthToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-Auth-Token"]) {
            headers = headers.set('X-Auth-Token', this.configuration.apiKeys["X-Auth-Token"]);
        }
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json; charset=utf-8',
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/live-events/${encodeURIComponent(String(liveEventId))}/catchup-url`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    getEpgList(params, filter, xLanguage, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({ encoder: new CustomParamFilterHttpUrlEncodingCodec() });
        if (params !== undefined && params !== null) {
            queryParameters = queryParameters.set('params', params);
        }
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('filter', filter);
        }
        let headers = this.defaultHeaders;
        if (xLanguage !== undefined && xLanguage !== null) {
            headers = headers.set('X-Language', String(xLanguage));
        }
        // authentication (ApiKeyXAuthToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-Auth-Token"]) {
            headers = headers.set('X-Auth-Token', this.configuration.apiKeys["X-Auth-Token"]);
        }
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json; charset=utf-8',
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/live-events`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
LiveEventsService.ɵfac = function LiveEventsService_Factory(t) { return new (t || LiveEventsService)(ɵɵinject(HttpClient), ɵɵinject(BASE_PATH, 8), ɵɵinject(Configuration, 8)); };
LiveEventsService.ɵprov = ɵɵdefineInjectable({ token: LiveEventsService, factory: LiveEventsService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(LiveEventsService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class MetadataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'https://spare-gmbh.tvf-rest001.tvfactory.ch/pa/sdp/v2';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    getBannersList(expand, observe = 'body', reportProgress = false) {
        if (expand === null || expand === undefined) {
            throw new Error('Required parameter expand was null or undefined when calling getBannersList.');
        }
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (expand !== undefined && expand !== null) {
            queryParameters = queryParameters.set('$expand', expand);
        }
        let headers = this.defaultHeaders;
        // authentication (ApiKeyXAuthToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-Auth-Token"]) {
            headers = headers.set('X-Auth-Token', this.configuration.apiKeys["X-Auth-Token"]);
        }
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json; charset=utf-8',
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/ads`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    getCategoryList(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // authentication (ApiKeyXAuthToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-Auth-Token"]) {
            headers = headers.set('X-Auth-Token', this.configuration.apiKeys["X-Auth-Token"]);
        }
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json; charset=utf-8',
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/categories`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    getGenreList(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // authentication (ApiKeyXAuthToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-Auth-Token"]) {
            headers = headers.set('X-Auth-Token', this.configuration.apiKeys["X-Auth-Token"]);
        }
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json; charset=utf-8',
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/genres`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    getInstanceInfo(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // authentication (ApiKeyXAuthToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-Auth-Token"]) {
            headers = headers.set('X-Auth-Token', this.configuration.apiKeys["X-Auth-Token"]);
        }
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json; charset=utf-8',
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/operators/me`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    getMetadata(expand, xLanguage, observe = 'body', reportProgress = false) {
        if (expand === null || expand === undefined) {
            throw new Error('Required parameter expand was null or undefined when calling getMetadata.');
        }
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (expand !== undefined && expand !== null) {
            queryParameters = queryParameters.set('$expand', expand);
        }
        let headers = this.defaultHeaders;
        if (xLanguage !== undefined && xLanguage !== null) {
            headers = headers.set('X-Language', String(xLanguage));
        }
        // authentication (ApiKeyXAuthToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-Auth-Token"]) {
            headers = headers.set('X-Auth-Token', this.configuration.apiKeys["X-Auth-Token"]);
        }
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json; charset=utf-8',
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/bootstrap`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
MetadataService.ɵfac = function MetadataService_Factory(t) { return new (t || MetadataService)(ɵɵinject(HttpClient), ɵɵinject(BASE_PATH, 8), ɵɵinject(Configuration, 8)); };
MetadataService.ɵprov = ɵɵdefineInjectable({ token: MetadataService, factory: MetadataService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MetadataService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class SubscriberService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'https://spare-gmbh.tvf-rest001.tvfactory.ch/pa/sdp/v2';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    changePasswordForm(oldPassword, newPassword, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // authentication (ApiKeyXAuthToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-Auth-Token"]) {
            headers = headers.set('X-Auth-Token', this.configuration.apiKeys["X-Auth-Token"]);
        }
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [
            'application/x-www-form-urlencoded'
        ];
        const canConsumeForm = this.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        }
        if (oldPassword !== undefined) {
            formParams = formParams.append('old_password', oldPassword) || formParams;
        }
        if (newPassword !== undefined) {
            formParams = formParams.append('new_password', newPassword) || formParams;
        }
        return this.httpClient.request('post', `${this.basePath}/subscribers/me/commands/change-password`, {
            body: convertFormParamsToString ? formParams.toString() : formParams,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    getCurrentDeviceInfo(expand, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (expand !== undefined && expand !== null) {
            queryParameters = queryParameters.set('$expand', expand);
        }
        let headers = this.defaultHeaders;
        // authentication (ApiKeyXAuthToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-Auth-Token"]) {
            headers = headers.set('X-Auth-Token', this.configuration.apiKeys["X-Auth-Token"]);
        }
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json; charset=utf-8',
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/devices/me`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    getCurrentSubscriber(expand, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (expand !== undefined && expand !== null) {
            queryParameters = queryParameters.set('$expand', expand);
        }
        let headers = this.defaultHeaders;
        // authentication (ApiKeyXAuthToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-Auth-Token"]) {
            headers = headers.set('X-Auth-Token', this.configuration.apiKeys["X-Auth-Token"]);
        }
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json; charset=utf-8',
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/subscribers/me`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    getOperatorList(username, observe = 'body', reportProgress = false) {
        if (username === null || username === undefined) {
            throw new Error('Required parameter username was null or undefined when calling getOperatorList.');
        }
        let headers = this.defaultHeaders;
        // authentication (ApiKeyXAuthToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-Auth-Token"]) {
            headers = headers.set('X-Auth-Token', this.configuration.apiKeys["X-Auth-Token"]);
        }
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json; charset=utf-8',
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/subscriber-usernames/${encodeURIComponent(String(username))}/instances`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    updateSubscriber(body, observe = 'body', reportProgress = false) {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateSubscriber.');
        }
        let headers = this.defaultHeaders;
        // authentication (ApiKeyXAuthToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-Auth-Token"]) {
            headers = headers.set('X-Auth-Token', this.configuration.apiKeys["X-Auth-Token"]);
        }
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json; charset=utf-8',
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [
            'application/json'
        ];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('patch', `${this.basePath}/subscribers/me`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
SubscriberService.ɵfac = function SubscriberService_Factory(t) { return new (t || SubscriberService)(ɵɵinject(HttpClient), ɵɵinject(BASE_PATH, 8), ɵɵinject(Configuration, 8)); };
SubscriberService.ɵprov = ɵɵdefineInjectable({ token: SubscriberService, factory: SubscriberService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SubscriberService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

const APIS = [AssetsService, AuthorizeService, LiveEventsService, MetadataService, SubscriberService];

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
class DataParam {
    constructor() {
        this.toString = () => {
            const codec = new CustomHttpUrlEncodingCodec();
            let result = '';
            for (const key of Object.keys(JSON.parse(JSON.stringify(this)))) {
                result += '&' + key + '=' + codec.encodeValue(this[key]);
            }
            return result;
        };
    }
}

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

class QueryParamMap extends Map {
    constructor() {
        super(...arguments);
        /* methods */
        this.toString = () => {
            let retValue = '';
            this.forEach((value, key) => {
                const nkey = Object.keys(value)[0];
                retValue += '&' + key + '[' + nkey + ']=' + value[nkey];
            });
            return retValue;
        };
    }
}

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * TVF CL Rest Client.
 * User: spare-01@tvfactory.ch
 *
 * OpenAPI spec version: 2.0
 * Contact: info@tvfactory.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

class ApiModule {
    constructor(parentModule, http) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
                'See also https://github.com/angular/angular/issues/20575');
        }
    }
    static forRoot(configurationFactory) {
        return {
            ngModule: ApiModule,
            providers: [{ provide: Configuration, useFactory: configurationFactory }]
        };
    }
}
ApiModule.ɵmod = ɵɵdefineNgModule({ type: ApiModule });
ApiModule.ɵinj = ɵɵdefineInjector({ factory: function ApiModule_Factory(t) { return new (t || ApiModule)(ɵɵinject(ApiModule, 12), ɵɵinject(HttpClient, 8)); }, providers: [
        AssetsService,
        AuthorizeService,
        LiveEventsService,
        MetadataService,
        SubscriberService
    ], imports: [[]] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ApiModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [],
                exports: [],
                providers: [
                    AssetsService,
                    AuthorizeService,
                    LiveEventsService,
                    MetadataService,
                    SubscriberService
                ]
            }]
    }], function () { return [{ type: ApiModule, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }, { type: HttpClient, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { APIS, ApiModule, AssetsService, AuthorizeService, BASE_PATH, COLLECTION_FORMATS, Configuration, DataParam, LiveEventsService, MetadataService, QueryParamMap, SubscriberService };
//# sourceMappingURL=tvf-rest-client.js.map
